module.exports = __webpack_public_path__ + "static/TT-Floorplan-Floor22-58d4d9f6737dd2bd097ca53d8c9b8786.jpg";